/** @jsxImportSource @emotion/react */
import { useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Text from '@Text';
import { useWidgetHeightRefresh } from '../../Hooks/useWidgetHeightRefresh/useWidgetHeightRefresh';
import { selectIsAddressListJourney } from '../../Helpers/clientApiJourneyPosition.helpers';
import { selectBookingLocation } from '../../Helpers/clientApiLocations.helpers';
import { getAppointmentRangeLabel } from './appointment.helpers';
import makeSlotPickerStyles from './makeSlotPickerStyles';
import useOlbScreenCopy from './copy/useOlbScreenCopy';
import SolarSummaryCard from './SolarSummaryCard';
import { buildCardRows } from './olbScreenCopy.helpers';

const BookingConfirmation = ({ stepKey }) => {
  const theme = useTheme();
  const classes = makeSlotPickerStyles({ theme });
  const copy = useOlbScreenCopy(stepKey, 'confirmation');
  const localeCode = useSelector((store) => store.formConfig?.localeCode);

  const isAddressJourney = useSelector(selectIsAddressListJourney);

  const selectedLocation = useSelector(selectBookingLocation);
  const selectedSlot = useSelector(
    (store) => store.clientApiJourney.appointment?.selectedSlot
  );
  const bookingReference = useSelector(
    (store) => store.clientApiJourney.appointment?.bookingReference
  );

  useWidgetHeightRefresh([]);

  const clinicRow = isAddressJourney
    ? []
    : [{ label: copy.clinic, value: selectedLocation?.title }];
  const rows = buildCardRows([
    {
      label: copy.reference,
      value: bookingReference,
      valueTestId: 'bookingReference',
    },
    {
      label: copy.appointment,
      value: getAppointmentRangeLabel(selectedSlot, localeCode),
    },
    { label: copy.address, value: selectedLocation?.address },
    ...clinicRow,
  ]);

  return (
    <Container
      css={classes.confirmationContainer}
      data-testid="bookingConfirmation"
    >
      <Box css={classes.confirmationTick} data-testid="confirmationTick">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 -960 960 960"
          fill="currentColor"
        >
          <path d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v362l-60 60v-232H180v430h327l60 60H180Zm0-550h600v-130H180v130Zm0 0v-130 130ZM672-60 542-190l42-43 88 88 175-175 43 42L672-60Z" />
        </svg>
      </Box>
      <Box css={classes.heading}>
        <Text variant="question">{copy.heading}</Text>
      </Box>
      <Box css={classes.subheading}>
        <Text variant="text">{copy.subheading}</Text>
      </Box>

      <SolarSummaryCard
        dataTestId="confirmationCard"
        inline
        dividers
        rows={rows}
      />
    </Container>
  );
};

export default BookingConfirmation;
